import { Component, OnInit, ViewChild } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable, of } from 'rxjs';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { ApiDocumentosService } from '../../shared/services/api-documentos.service';
import { Proceso, Empresa } from 'src/app/classes/coordinador';
import { ApiProcesosService } from 'src/app/shared/services/api-procesos.service';
import { ApiEmpresasService } from 'src/app/shared/services/api-empresas.service';
import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { FiltrosDespliegueComponent } from './filtros/filtros.component';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver/dist/FileSaver';
import { AppStorage } from 'src/app/shared/services/appStorage.service';

@Component({
  selector: 'app-despliegue',
  templateUrl: './despliegue.component.html',
  styleUrls: ['./despliegue.component.css'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', visibility: 'hidden' })
      ),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      )
    ])
  ]
})
export class DespliegueComponent implements OnInit {
  @ViewChild(FiltrosDespliegueComponent)
  filtrosComponent: FiltrosDespliegueComponent;

  // Loading
  loadingProcesos;
  loadingEmpresas;
  loadingDocumentos;

  procesos: Proceso[];
  empresas: Empresa[];

  // Data
  checkTodos;

  constructor(
    private apiDocumentosService: ApiDocumentosService,
    private apiProcesosService: ApiProcesosService,
    private apiEmpresasService: ApiEmpresasService,
    private appStorage: AppStorage
  ) {}

  documentos: any[];
  documentosAgrupados;
  documentosAgrupadosFiltrados;
  documentosPaginados;
  documentosAComprimir;

  ngOnInit() {
    this.cargarEmpresas();
    this.cargarProcesos();
  }

  cargarProcesos() {
    this.loadingProcesos = true;
    this.apiProcesosService
      .getProcesos()
      .then((res: any) => {
        this.procesos = res;
        this.procesos.sort(function(a, b) {
          if (a.sigla < b.sigla) {
            return -1;
          }
          if (a.sigla > b.sigla) {
            return 1;
          }
          return 0;
        });
        this.loadingProcesos = false;
      })
      .catch(error => {
        this.loadingProcesos = false;
      });
  }

  cargarEmpresas() {
    this.loadingEmpresas = true;
    this.apiEmpresasService
      .getEmpresasUsuarioEmpresa()
      .then((res: any) => {
        this.empresas = res;
        this.empresas = this.empresas.filter(item => item.sigla !== null);
        this.empresas.sort(function(a, b) {
          if (a.sigla < b.sigla) {
            return -1;
          }
          if (a.sigla > b.sigla) {
            return 1;
          }
          return 0;
        });
        this.loadingEmpresas = false;
      })
      .catch(error => {
        this.loadingEmpresas = false;
        console.error(error);
      });
  }

  hayCambiosEnFiltro() {
    this.documentosAComprimir = [];
    this.checkTodos = false;

    if (
      this.filtrosComponent.filtrosSeleccionados.anno &&
      this.filtrosComponent.filtrosSeleccionados.mes &&
      this.filtrosComponent.filtrosSeleccionados.mes.numero &&
      this.filtrosComponent.filtrosSeleccionados.proceso
    ) {
      this.loadingDocumentos = true;
      this.apiDocumentosService
        .getAllDocumentosUsuarioEmpresa(
          this.filtrosComponent.filtrosSeleccionados.anno,
          this.filtrosComponent.filtrosSeleccionados.mes.numero,
          this.filtrosComponent.filtrosSeleccionados.proceso
        )
        .then((documentos: any) => {
          this.documentos = documentos;
          this.agruparDocumentos();
          this.hayCambioDeEmpresa();
          this.loadingDocumentos = false;
        })
        .catch(() => {
          this.documentos = [];
          this.agruparDocumentos();
          this.hayCambioDeEmpresa();
          this.paginar({
            pageIndex: 0,
            pageSize: 25
          });
          this.loadingDocumentos = false;
        });
    }
  }

  hayCambioDeEmpresa() {
    if (this.documentosAgrupados) {
      this.documentosAgrupadosFiltrados = JSON.parse(
        JSON.stringify(this.documentosAgrupados)
      );

      if (this.filtrosComponent.filtrosSeleccionados.empresa) {
        this.documentosAgrupadosFiltrados = this.documentosAgrupadosFiltrados.filter(
          item => {
            return (
              item.idEmpresa ===
              this.filtrosComponent.filtrosSeleccionados.empresa.idEmpresa
            );
          }
        );
      }

      this.paginar({
        pageIndex: 0,
        pageSize: 25
      });
    }
  }

  paginar(pageEvent) {
    this.documentosPaginados = [];
    const init = pageEvent.pageIndex * pageEvent.pageSize;
    for (
      let index = pageEvent.pageIndex * pageEvent.pageSize;
      index < this.documentosAgrupadosFiltrados.length &&
      index < init + pageEvent.pageSize;
      index++
    ) {
      this.documentosPaginados.push(this.documentosAgrupadosFiltrados[index]);
    }
  }

  agruparDocumentos() {
    this.documentos.sort((d1, d2) => {
      if (d1.estado === 'Publicado') {
        return -1;
      }
      return 1;
    });

    this.documentosAgrupados = [];
    for (const documento of this.documentos) {
      if (documento.estado === 'Publicado') {
        documento.documentosHistoricos = [];
        this.documentosAgrupados.push(documento);
      } else {
        const documentoAgrupado = this.buscarDocumentoPublicado(documento);
        if (documentoAgrupado) {
          documentoAgrupado.documentosHistoricos.push(documento);
        }
      }
    }

    for (const documento of this.documentosAgrupados) {
      documento.documentosHistoricos.sort((d1, d2) => {
        return d1.version.localeCompare(d2.version) * -1;
      });
    }

    this.documentosAgrupados.sort((d1, d2) => {
      return d1.sigla.localeCompare(d2.sigla);
    });
  }

  buscarDocumentoPublicado(documento) {
    for (const documentoAgrupado of this.documentosAgrupados) {
      if (
        documentoAgrupado.nombreArchivo.substring(0, 2) ===
          documento.nombreArchivo.substring(0, 2) &&
        documentoAgrupado.nombreArchivo.substring(4) ===
          documento.nombreArchivo.substring(4)
      ) {
        return documentoAgrupado;
      }
    }

    return false;
  }

  changeCheckTodos() {
    if (this.checkTodos) {
      for (const documentoAgrupado of this.documentosAgrupadosFiltrados) {
        documentoAgrupado.checked = true;

        for (const documentoHistorico of documentoAgrupado.documentosHistoricos) {
          documentoHistorico.checked = false;
        }
      }
    } else {
      for (const documentoAgrupado of this.documentosAgrupadosFiltrados) {
        documentoAgrupado.checked = false;

        for (const documentoHistorico of documentoAgrupado.documentosHistoricos) {
          documentoHistorico.checked = false;
        }
      }
    }
  }

  changeCheck() {
    this.checkTodos = false;
  }

  hayCheck() {
    for (const doc of this.documentosAgrupadosFiltrados) {
      if (doc.checked) {
        return true;
      }

      for (const docHistorico of doc.documentosHistoricos) {
        if (docHistorico.checked) {
          return true;
        }
      }
    }
    return false;
  }

  descargaMasiva() {
    this.documentosAComprimir = [];
    for (const doc of this.documentosAgrupadosFiltrados) {
      if (doc.checked) {
        this.documentosAComprimir.push({
          url: doc.url,
          nombre: doc.nombreArchivo
        });
      }

      for (const docHistorico of doc.documentosHistoricos) {
        if (docHistorico.checked) {
          this.documentosAComprimir.push({
            url: docHistorico.url,
            nombre: docHistorico.nombreArchivo
          });
        }
      }
    }

    this.appStorage.loadingGeneral = true;
    for (const doc of this.documentosAComprimir) {
      this.apiDocumentosService
        .descargarDocumento(doc.url)
        .then((res: any) => {
          doc.data = res;
          this.comprimir();
        })
        .catch(error => {
          doc.data = 'no_data';
          this.comprimir();
          console.log(error);
        });
    }
  }

  comprimir() {
    let count = 0;
    for (const doc of this.documentosAComprimir) {
      if (doc.data) {
        count++;
      }
    }

    if (count === this.documentosAComprimir.length) {
      // comprimir
      const zip = new JSZip();

      for (const doc of this.documentosAComprimir) {
        if (doc.data !== 'no_data') {
          zip.file(doc.nombre, doc.data, { binary: true });
        }
      }
      const zipFile = zip.generateAsync({ type: 'blob' }).then(blob => {
        saveAs(blob, 'archivos.zip');
      });
      this.appStorage.loadingGeneral = false;
    }
  }
}
